import { Spinner, theme } from '@zappyrent/hundop';
import { rgba } from 'polished';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { StyledWrapper } from './LoadingPage.styles';
import { ILoadingPageProps } from './LoadingPage.types';
import { StyledH2 } from '../../components/UI/Typography';

const DEFAULT_REFERRAL_LANDING_URL =
  'https://proprietari.zappyrent.com/referral/';

const LoadingPage = ({ title }: ILoadingPageProps): JSX.Element => {
  const { invitationCode } = useParams();

  useEffect(() => {
    if (!invitationCode) return;

    const landingBaseUrl =
      process.env.REACT_APP_REFERRAL_LANDING_URL ??
      DEFAULT_REFERRAL_LANDING_URL;
    const landingUrl = new URL(landingBaseUrl);

    landingUrl.searchParams.set('invitation_code', invitationCode);
    window.location.replace(landingUrl.toString());
  }, [invitationCode]);

  return (
    <StyledWrapper>
      <StyledH2>{title}</StyledH2>
      <Spinner
        backgroundColor={rgba(theme.colors.landlord.main, 0.2)}
        foregroundColor={theme.colors.landlord.main}
        size={40}
        strokeSize={4}
      />
    </StyledWrapper>
  );
};

export default LoadingPage;
